import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('what_kind_of_documents_you_want_to_approve'),
    subtitle: defineMessage('pick_one_type_now_you_c_ypes_of_documents_later'),
    other: defineMessage('other_eg_travel_requests_or_contracts'),
    popular: defineMessage('popular'),
};
